import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import { Action } from '../../models/action';

export class TradeDeskActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.TRADEDESKACTION, apiHelper);
  }
}
